// ── Compensation Source Enums ─────────────────────────────────────────────────
export const COMP_SOURCE = {
  ACTUAL: 'ACTUAL',
  AI_GENERATED: 'AI_GENERATED',
  MISSING: 'MISSING',
};

// ── Currency Options (ISO 4217) ───────────────────────────────────────────────
export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD' },
  { value: 'INR', label: 'INR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'EUR', label: 'EUR' },
];

// ── Update Channel ────────────────────────────────────────────────────────────
export const UPDATE_CHANNEL = {
  ADMIN_UI: 'ADMIN_UI',
  BULK_IMPORT: 'BULK_IMPORT',
  CUSTOMER_FEED: 'CUSTOMER_FEED',
  AI_PIPELINE: 'AI_PIPELINE',
  BACKEND_SCRIPT: 'BACKEND_SCRIPT',
};

// ── Pagination Defaults ───────────────────────────────────────────────────────
export const COMP_PAGE_SIZE = 10;
export const COMP_PAGE_SIZE_OPTIONS = ['10', '20', '30', '50'];

// ── Tab Keys ──────────────────────────────────────────────────────────────────
export const COMP_TAB_KEYS = {
  COMP_POSITION: 'comp_position',
  CURRENCY_SETTINGS: 'currency_settings',
};

export const COMP_TABS = [
  { key: COMP_TAB_KEYS.COMP_POSITION, label: 'Comp & Position' },
  { key: COMP_TAB_KEYS.CURRENCY_SETTINGS, label: 'Currency Settings' },
];

// ── Backend Error Codes ───────────────────────────────────────────────────────
export const COMP_ERROR_CODES = {
  // Currency Settings
  MISSING_PARAM: 7000,
  INVALID_JWT: 7001,
  MISSING_FIELD: 7002,
  NOT_FOUND: 7026,
  BQ_QUERY_FAILED: 7040,
  INTERNAL_ERROR: 7111,
  READ_ONLY_FIELD: 7403,
  // Compensation
  COMP_EXISTS_OR_NOT_FOUND: 7302,
  NO_FIELDS_FOR_UPDATE: 7304,
  INVALID_POSITIONS: 7306,
  INVALID_COMPENSATION: 7308,
  FX_RATE_NOT_CONFIGURED: 7309,
  VALUE_UNCHANGED: 7310,
  // Bulk Upload
  FILE_PARSE_ERROR: 7500,
};

// ── Messages ──────────────────────────────────────────────────────────────────
export const COMP_MESSAGES = {
  LOAD_FAILED: 'Failed to load compensation data',
  LOAD_FAILED_DESC: 'Unable to fetch compensation records. Please try again.',
  SAVE_SUCCESS: 'Compensation updated successfully',
  SAVE_FAILED: 'Failed to save compensation',
  SAVE_FAILED_DESC: 'Unable to save compensation data. Please try again.',
  INSERT_SUCCESS: 'Compensation record created successfully',
  INSERT_FAILED: 'Failed to create compensation record',
  NO_RECORDS: 'No records found',
  MISSING_WARNING_PREFIX: 'jobs are missing compensation data. PAIC runs for these jobs may produce less accurate outputs.',
  // Specific error messages mapped to error codes
  ERR_FX_NOT_CONFIGURED: 'FX rate not configured',
  ERR_FX_NOT_CONFIGURED_DESC: 'Please configure the FX rate for this legal entity in the Currency Settings tab before entering compensation.',
  ERR_INVALID_COMP: 'Invalid compensation value',
  ERR_INVALID_COMP_DESC: 'Compensation must be a non-negative number.',
  ERR_VALUE_UNCHANGED: 'Value unchanged',
  ERR_VALUE_UNCHANGED_DESC: 'The compensation value is the same as the current one. Please enter a different amount.',
  ERR_NO_FIELDS: 'No fields to update',
  ERR_NO_FIELDS_DESC: 'Please provide at least a compensation amount or total positions to update.',
  ERR_INVALID_POSITIONS: 'Invalid total positions',
  ERR_INVALID_POSITIONS_DESC: 'Total positions must be a positive whole number.',
  ERR_RECORD_EXISTS: 'Record already exists',
  ERR_RECORD_EXISTS_DESC: 'A compensation record already exists for this job. Use Edit to update it.',
  ERR_SESSION_EXPIRED: 'Session expired',
  ERR_SESSION_EXPIRED_DESC: 'Your session has expired. Please refresh the page and log in again.',
  ERR_NOT_FOUND: 'Resource not found',
  ERR_NOT_FOUND_DESC: 'The requested resource was not found. It may have been deleted.',
  ERR_SERVER: 'Server error',
  ERR_SERVER_DESC: 'An unexpected server error occurred. Please try again later.',
};

// ── Currency Settings Messages ────────────────────────────────────────────────
export const CURRENCY_MESSAGES = {
  LOAD_FAILED: 'Failed to load currency settings',
  LOAD_FAILED_DESC: 'Unable to fetch currency settings. Please try again.',
  SAVE_SUCCESS: 'Currency setting updated successfully',
  SAVE_FAILED: 'Failed to update currency setting',
  SAVE_FAILED_DESC: 'Unable to save the FX rate. Please try again.',
  READ_ONLY: 'local_currency is read-only and cannot be modified',
  READ_ONLY_DESC: 'The local currency is derived from the organization structure and cannot be changed here.',
  ERR_ENTITY_NOT_FOUND: 'Legal entity not found',
  ERR_ENTITY_NOT_FOUND_DESC: 'The specified legal entity was not found in the organization structure.',
};
